import { create } from 'zustand';
import * as documentsApi from './documentsApi';
import type { DocFile, DocFolder } from './documentsApi';

export type { DocFile, DocFolder };

interface DocumentsState {
  files: DocFile[];
  folders: DocFolder[];
  loading: boolean;
  /** Set when the last document load failed — screens must not show "no documents" for it. */
  error: string | null;
  fetchDocuments: (caseId?: string) => Promise<void>;
  fetchFolders: (caseId?: string) => Promise<void>;
  deleteDocument: (id: string) => void;
}

export const useDocumentsStore = create<DocumentsState>()((set, get) => ({
  files: [],
  folders: [],
  loading: false,
  error: null,

  fetchDocuments: async (caseId) => {
    set({ loading: true, error: null });
    try {
      const files = await documentsApi.fetchDocuments(caseId);
      set({ files, loading: false });
    } catch (err) {
      console.error('Failed to fetch documents:', err);
      set({ loading: false, error: 'Documents could not be loaded' });
    }
  },

  fetchFolders: async (caseId) => {
    try {
      const folders = await documentsApi.fetchFolders(caseId);
      set({ folders });
    } catch (err) {
      console.error('Failed to fetch folders:', err);
    }
  },

  deleteDocument: (id) => {
    const removed = get().files.find((f) => f.id === id);
    set((s) => ({ files: s.files.filter((f) => f.id !== id) }));
    documentsApi.deleteDocument(id).catch((err) => {
      console.error('Failed to delete document:', err);
      if (removed) set((s) => ({ files: [removed, ...s.files] }));
    });
  },
}));
